import { Divider, Stack } from '@mui/material';
import { useRef, type UIEventHandler } from 'react';

import { Icon } from '@/components/shared/icon';

export const SelectedItemsBody = <T,>({
  items,
  renderItem,
  itemKey,
  onRemove,
  onScrollVerticallyChange,
}: {
  items: T[];
  renderItem: (item: T) => React.ReactNode;
  itemKey: (item: T) => string;
  onRemove: (item: T) => void;
  onScrollVerticallyChange?: (isScrolled: boolean) => void;
}) => {
  const isScrolledVertically = useRef(false);

  const onScroll: UIEventHandler<HTMLDivElement> = (event) => {
    const target = event.target as HTMLDivElement;
    if (typeof target.scrollTop === 'number') {
      const isScrolled = target.scrollTop > 0;
      if (isScrolled !== isScrolledVertically.current) {
        isScrolledVertically.current = isScrolled;
        onScrollVerticallyChange?.(isScrolled);
      }
    }
  };

  return (
    <Stack
      flexGrow={1}
      overflow='auto'
      height='auto'
      className='py-[12px]'
      gap='8px'
      divider={<Divider sx={{ paddingY: '2px' }} />}
      onScroll={onScrollVerticallyChange ? onScroll : undefined}
    >
      {items.map((item) => (
        <Stack
          width='100%'
          direction='row'
          alignItems='center'
          key={itemKey(item)}
          justifyContent='space-between'
          className='px-[24px]'
        >
          {renderItem(item)}
          <Icon
            onClick={() => onRemove(item)}
            iconClass='material-symbols-close-rounded'
          />
        </Stack>
      ))}
    </Stack>
  );
};
